// extracted by mini-css-extract-plugin
module.exports = {"sample":"sample_sample__LoPBA"};